import * as yup from 'yup'

export class VehicleCheckInCheckInClusterPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInCheckInClusterPhotoFile?: File = undefined
  alsoUseForOdometerBeforeModificationPhoto?: boolean = undefined
}

export const vehicleCheckInCheckInClusterPhotoValidationSchema = yup.object({
  vehicleCheckInCheckInClusterPhotoFile: yup.mixed().notRequired(),
  alsoUseForOdometerBeforeModificationPhoto: yup.boolean().notRequired()
})
